module.exports = __webpack_public_path__ + "static/img/s_5.479f5ae5.png";